/* CreateAction.js */

"use strict";
const Registrations = require("../../../../../RegistrationNamespaces");
const CreateQuestionComponent = require("./CreateQuestionComponent");

class CreateAction {
    constructor(
        logger,
        gameEditor,
        modalUserFeedback,
        NetworkDiscoveryPlan,
        userSession,
        activeView
    ) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._networkDiscoveryPlan = new NetworkDiscoveryPlan(userSession.activeOrganization.id);

        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this.run = this.run.bind(this);
    }

    run() {
        return this._modalUserFeedback
            .displayCustom(new CreateQuestionComponent(this._logger), {dontHide: true})
            .then((result) => {
                this._modalUserFeedback.displayLoading();
                return this._createPlan(result.trim()).catch((err) => {
                    this._logger.warn(
                        {error: err},
                        "CreateAction._createNetworkDiscoveryPlan() error."
                    );
                    return this._modalUserFeedback.displayError(err);
                });
            })
            .then((result) => {
                let editorState = {
                    fqn: Registrations.NETWORK_DISCOVERY_EDITOR_VIEW_DETAILS,
                    viewState: {createMode: true},
                };
                let launchOpts = {
                    id: result.id,
                    title: result.properties.name,
                };
                this._modalUserFeedback.hideDisplayed();
                this._gameEditor.launchNetworkDiscoveryEditor(editorState, launchOpts);
                if (
                    typeof this._activeView.resetSelection === "function" &&
                    typeof this._activeView.loadAndScrollTo === "function"
                ) {
                    this._activeView.resetSelection([result.id]);
                    this._activeView.loadAndScrollTo(result.id);
                }
            })
            .catch((err) => {
                this._modalUserFeedback.hideDisplayed();
                this._logger.warn(
                    {error: err},
                    "CreateAction.run() - Either error or cancellation"
                );
            });
    }

    _createPlan(name) {
        // Defaults
        this._networkDiscoveryPlan.name = name;
        return this._networkDiscoveryPlan.create();
    }
}

module.exports = CreateAction;

CreateAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.NetworkDiscoveryPlan",
    "$teve.userSession",
    "gameEditor.activeView",
];

CreateAction.$displayDetails = {
    type: "Action",
    name: "CreateAction",
    icon: "networkdiscovery.add_network_discovery",
    shown: true,
    title: "Add Discovery Plan",
    order: 2,
};
